<template>
  <div id="smartbox">
    <div class="row scheda"
         v-bind:style="{height: (myWidth < 768) ? 'auto' : 'auto', backgroundImage: 'url(static/image/attivita/' + wine.foodImage + ')', minHeight: myHeight + 'px'}">
      <div class="col-lg-6 dati">
        <div class="datiin">
          <div class="col-lg-12 titolo"><h1>{{wine.nome}}</h1></div>
          <!-- Descrizione -->
          <div class="col-lg-12 sez">
            <div class="sottotitolo">
              <img src="../../static/image/vitigni.png" class="foto">
              <span>{{$t("wines")}}</span>
            </div>
            <div class="testo" v-html="wine.descr">
            </div>
          </div>
          <!-- Dettaglio -->
          <div class="col-lg-12 sez">
            <div class="sottotitolo">
              <img src="../../static/image/degustazione.png" class="foto">
              <span>{{$t("details")}}</span>
            </div>
            <div class="testo" v-html="wine.vitigni">
            </div>
          </div>
          <!-- Prezzo -->
          <div class="col-lg-12 sez">
            <div class="sottotitolo">
              <img src="../../static/image/prezzowhite.png" style="width: 45px; margin-right: 13px">
              <span>{{$t("price")}}</span>
            </div>
            <div class="testo" v-price v-if="wine.price">{{wine.price}}</div>
          </div>
          <div class="row">
            <div class="quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                                    min="1" :max="wine.qntyProd"
                                                                                    class="quantità"
                                                                                    id="qua"
                                                                                    oninput="validity.valid||(value=1)"
                                                                                    v-model="qntyOrd"
                                                                                    v-validate="'required'">
            </div>
            <div class="btncont">
              <b-btn class="info" @click="addToCart">Aggiungi al carrello</b-btn>
              <b-btn class="info" :to="{name: 'shop'}">{{$t("shop")}}
              </b-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import MainSlider from './MainSlider'
  import Footer from './Footer'
  import Bus from './Bus'

  export default {
    name: 'SmartBox',
    components: {Footer, MainSlider},
    data() {
      return {
        myHeight: window.innerHeight,
        myWidth: window.innerWidth,
        qntyOrd: 1,
        wine: {
          nome: '',
          category: '',
          vitigni: '',
          vendemmia: '',
          produzione: '',
          caratteristiche: '',
          food: '',
          foodImage: '',
          price: ''
        }
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          wines: 'Descrizione',
          details: 'Dettagli',
          price: 'Prezzo',
          shop: 'Vai allo Shop',
          prod_add: 'Prodotto aggiunto al carrello',
          prb_prod_add: 'Errore, inserire quantità'
        },
        en: {
          wines: 'Description',
          details: 'Details',
          price: 'Price',
          shop: 'Go to the Shop',
          prod_add: 'Prodotto aggiunto al carrello',
          prb_prod_add: 'Errore, inserire quantità'
        }
      }
    },
    watch: {
      '$i18n.locale': function () {
        this.getWine()
      }
    },
    methods: {
      addToCart: function () {
        let idCarrello = localStorage.getItem('idCarrello') === null || localStorage.getItem('idCarrello') === undefined ? '0' : localStorage.getItem('idCarrello')
        let data = {
          idCartEncrypted: idCarrello,
          idProduct: this.wine.id,
          qntyOrd: this.qntyOrd
        }
        this.$http.post('/ws-shop/cart/add', data).then(response => {
          if (response.body.idCart) {
            localStorage.setItem('idCarrello', response.body.idCart)
          }
          if (response.body.rc === 0) {
            this.$toasted.show(this.$t('prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'success',
              duration: 4000
            })
            Bus.$emit('totCart')
          } else {
            this.$toasted.show(this.$t('prb_prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      },
      getWine: function () {
        let lang = this.$root.$i18n.locale === 'it' ? 'ita' : 'eng'
        this.$http.get('/ws-shop/products/' + this.$route.params.id, {params: {'lang': lang}}).then(response => {
          this.wine = response.body.data
          this.$forceUpdate()
        })
      }
    },
    mounted: function () {
      this.getWine()
      window.scroll(0, 0)
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #smartbox input[type=number] {
    text-align: center;
    font-weight: 700;
    outline: none;
  }

  #smartbox {
    .main {
      .agile {
        .agile__track {
          max-height: 600px;
        }
      }
    }
    .scheda {
      margin-right: 0px;
      color: white;
      padding-bottom: 30px;
      background-size: cover;
      padding-top: 110px;
      .dati {
        padding-left: 100px;
        .datiin {
          border: 0.5px;
          border-style: solid;
          border-color: white;
          background-color: @lightBlack;
          padding: 20px;
          .titolo {
            padding-left: 8%;
            border: 1px;
            border-bottom: .5px;
            border-bottom-style: solid;
            border-bottom-color: white;
            height: 60px;
            text-align: left;
            margin-bottom: 10px;
            margin-top: 10px;
            .set-font-title(@weight: bold);
          }
          .sez {
            padding-bottom: 20px;
          }
          .sottotitolo {
            .set-font-title(@weight: bold, @size: 25px);
            .foto {
              margin-right: 20px;
              width: 35px;
            }
          }
          .testo {
            padding-left: 70px;
            letter-spacing: 1px;
            .set-font();
          }
          .quantity {
            .set-font-latoRegular();
            margin: auto;
            margin-top: 10px;
            margin-left: 40px;
            .quantità {
              width: 50%;
              height: 40%;
              background-color: #585353;
              color: white;
              border-color: @darkGray;
            }
          }
          .btncont {
            text-align: right;
            .info {
              width: 200px;
              background-color: @myOrange;
              border-color: @borderOrange;
              margin: auto;
              text-align: center;
              letter-spacing: 1px;
              margin-top: 5px;
              padding-top: 10px;
              padding-bottom: 10px;
              .set-font()
            }
          }
        }
      }
      .fotona {
        display: block;
        margin: auto;
      }
      .foto {
        width: 30%;
      }
    }
  }

  @media (max-width: 767px) {
    #smartbox {
      h1 {
        font-size: 1.8rem;
      }
      .row {
        margin-left: 0px;
        margin-right: 0px;
      }
      .scheda {
        padding-top: 45px;
        padding-right: 3px;
        .fotona {
          width: 45%;
        }
        .dati {
          padding: 10px;
          padding-top: 10%;
          .datiin {
            .titolo {
              height: 55px;
              margin-bottom: 20px;
              padding-left: 10px;
              .set-font-title(@weight: bold, @size: 37px);
            }
            .sez {
              padding-bottom: 1px;
              padding-right: 1px;
              padding-left: 1px;
            }
            .sottotitolo {
              .set-font-title(@weight: bold, @size: 20px);
              .foto {
              }
            }
            .testo {
              padding-left: 50px;
              .set-font(@size: 14px);
            }
            .quantity {
              .set-font-latoRegular();
              margin: auto;
              margin-top: 20px;
              padding-bottom: 20px;
              .quantità {
                width: 50%;
              }
            }
            .btncont {
              margin: auto;
              text-align: center;
              .info {
                width: 65%;
                .set-font(@size: 11px);
                .link {
                }
              }
            }
          }
        }
        .foto {
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #smartbox {
      .scheda {
        .dati {
          padding-left: 60px;
          padding-top: 35px;
          .titolo {
          }
          .sez {
            padding-bottom: 5px;
          }
          .sottotitolo {
            .foto {
            }
          }
          .testo {
            padding-left: 80px;
          }
          .info {
            .link {
            }
          }
        }
        .foto {
        }
      }
    }
  }

  @media (min-width: 1024px) and (max-width: 1366px) {
    #smartbox {
      h1 {
        font-size: 1.8rem;
      }
      .scheda {
        .dati {
          .titolo {
          }
          .sez {
            padding-bottom: 10px;
          }
          .sottotitolo {
            .foto {
            }
          }
          .testo {
            padding-left: 60px;
          }
          .info {
            .link {
            }
          }
        }
        .foto {
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SmartBox.vue